/* A collection of Array utility functions */

/**
 * Gets a random index from an array.
 * @param arr
 */
export function getRandomIndex(arr: unknown[]): number {
  return Math.floor(arr.length * Math.random());
}

/**
 * Gets a random element from an array.
 * @param arr
 */
export function getRandomElement<T>(arr: T[]): T {
  return arr[getRandomIndex(arr)];
}

/**
 * Removes a random element from an array.
 * @param arr
 * @param element
 */
export function removeElement(arr: unknown[], element: unknown): void {
  const index = arr.indexOf(element);
  if (index !== -1) arr.splice(index, 1);
}

/**
 * Removes a random element from an array.
 * @param arr
 */
export function removeRandomElement<T>(arr: T[]): T {
  return arr.splice(getRandomIndex(arr), 1)[0];
}

/**
 * Clones an array
 * @param arr
 */
export function cloneArray<T>(arr: T[]): T[] {
  return arr.slice();
}

/**
 * Filters an array to only unique elements.
 * @param arr
 */
export function filterUnique<T>(arr: T[]): T[] {
  return arr.filter((value, index, self) => self.indexOf(value) === index);
}

/**
 * Return a shuffled duplicate of an array.
 * @param arr
 */
export function shuffle<T>(arr: T[]): T[] {
  const copyArr = cloneArray(arr);
  const jumbledArr = [];
  while (copyArr.length > 0) {
    jumbledArr.push(removeRandomElement(copyArr));
  }
  return jumbledArr;
}

/**
 * Return a shuffled duplicate of an array.
 * If the array is less then the minLength the array will have its elements duplicated until the arrays length is >= minLength.
 * @param arr
 * @param minLength
 */
export function shuffleToMinLength<T>(arr: T[], minLength: number): T[] {
  const copyArr: T[] = [];
  while (copyArr.length < minLength) copyArr.push(...arr);
  return shuffle(copyArr);
}

export function moveElementFromIndexToIndex<T>(arr: T[], oldIndex: number, newIndex: number): void {
  const elem = arr.splice(oldIndex, 1)[0];
  arr.splice(newIndex, 0, elem);
}
